import { mapGetters } from 'vuex'
import { randomKey } from '@/utility/helpers'
export default {
    computed: {
        ...mapGetters(['extensionOptions', 'getErrorMessage']),
        //  Indicates if we show 'MessagePreview' when sending a message
        showPreview() {
            //  Get our message preview setting
            const setting = this.$store.getters.settingGet('showMessagePreview')

            //  If the setting doesn't exist, default to true
            if (!setting) return true

            //  Else, return the enabled setting on it
            return setting.enabled
        }
    },
    methods: {
        hasNoDeliveryReceipt(message) {
            //  Check if the message contains the 'No Delivery Receipt' error code
            const hasNoReceipt = parseInt(message.standard_err) === 9

            //  Return the result
            return hasNoReceipt
        },
        //  Finds the per-message character limit
        messageCharLimit(text) {
            //  Check if the message contains emojis
            const hasEmojis = text.length !== twemoji.parse(text).length

            //  If the message has emojis, the character limit is 70
            if (hasEmojis) return 70

            //  Else, the default chacter limit is 160
            return 160
        },
        popFailedMessage(message) {
            //  Get the error message
            const err = this.getErrorMessage(message)

            //  Parse our message
            const msg = this.$options.filters.parseMessageText(err.message)

            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: `Message Failed`,
                text: `<div style="margin-top:10px"><b>Reason: </b><i>${err.reason}</i><div><div style="margin-top:10px">${msg}</div><br>Would you like to resend this message?`,
                icon: 'bi-send-x-fill',
                callback: async (result) => {
                    //  If the user answered 'NO' do nothing
                    if (!result) return

                    //  Assemble message payload
                    const payload = {
                        channel_id: message.channel_id,
                        text: message.text,
                        media_id: message.media_id,
                        template_id: message.template_id,
                        outbound: message.outbound,
                        type: message.type
                    }

                    //  Post the message to the API
                    const response = await this.$store.dispatch('messagesPost', payload)

                    //  If the request failed, do nothing
                    if (!response) return

                    //  Else, handle successfully sent message
                    this.$emit('onMessagesSent', [response])

                    //  Notify the user of successful message send
                    this.$store.commit('notificationPopupOpen', {
                        title: 'Message(s) Sent',
                        icon: 'bi-chat-square-dots-fill',
                        id: randomKey()
                    })
                }
            })
        },
        //  Pop the message preview
        popMessagePreview(message) {
            //  Pop the message preview
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Message Preview',
                icon: 'mdi-message-processing',
                color: 'primary',
                component: 'message-preview',
                overflow: 'auto',
                closeable: true,
                props: {
                    media: message.media,
                    message: message,
                    person: this.selectedPerson,
                    type: message.type,
                    callback: (messages) => {
                        //  Reset the message text form
                        this.$refs.messageForm.reset()
                    }
                }
            })
        },
        popSchedulingDisabled() {
            this.$store.dispatch('dialogOpen', {
                type: 'FEATURE',
                paywall_type: 'access',
                metadata: 'scheduling_enabled',
            })
        },
        popStatusMessage(message) {
            //  Get the message status
            let s = message.status

            //  If a status does NOT exist, do nothing
            if (!s) return

            //  If the message has 'No Delivery Receipt', set status to 'expired' (So we can display a special message)
            if (this.hasNoDeliveryReceipt(message)) s = 'expired'

            //  Select the status message
            const statusMsg = {
                sending: "This message is in the process of sending. once we confirm it was delivered we'll update the status to Delivered",
                sent: `The message was sent successfully, we're waiting for delivery confirmation`,
                delivered: `The message was delivered successfully`,
                expired: `The message was sent, but we never got confirmation it was delivered. In most cases, the message was delivered as expected.`,
                comment: 'This message is a comment and did not get sent to this contact. Only you and your teammates can see this.'
            }[s]

            //  Select the message title
            const title = {
                sending: 'Message Sending',
                sent: 'Message Sent',
                delivered: 'Message Delivered',
                expired: 'No Delivery Confirmation',
                comment: 'Message Comment'
            }[s]

            //  Select the message icon
            const i = s === 'expired' ? 'bi-send-exclamation-fill' : 'bi-send-check-fill'

            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: title,
                text: statusMsg,
                icon: i
            })
        },
        //  Validate tenant and recipient requirements before sending a message (forward valid message to popMessagePreview)
        async validateMessageSend(obj) {

            //  If our setting for message preview is enabled OR we are sending a schedule, then pop message preview
            if (this.showPreview || obj.type === 'schedule') return this.popMessagePreview(obj)

            //  Tell our message form to start loading (ux on send button)
            this.$refs.messageForm.sending = true

            //  Else, we don't want the preview so just send
            const messages = await this.$store.dispatch('messagesPost', obj)

            //  If the message send failed, do nothing
            if (!messages) return

            //  Our message is sent, tell our form to stop loading
            this.$refs.messageForm.sending = false

            //  Reset the message text form
            this.$refs.messageForm.reset()
        }
    }
}
